import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import React from "react"
import { useFormConfig } from "./hooks/useFormConfig"
import { FormProvider } from "react-hook-form"
import RenderFormSection from "./RenderFormSection"
import { useSnackbar } from "notistack"

export const AutocompleteCreator = ({
  parent = {}, fields = [], optionsMap = {},
  onSubmit = () => { }, onError = () => { },
  ...props }) => {
  const form = useFormConfig(fields)
  const { enqueueSnackbar } = useSnackbar()

  const handleSubmit = async (data) => {
    const newValue = await onSubmit(data)

    if (newValue?.value && newValue?.description) {
      parent.onChange(null, newValue)
      enqueueSnackbar(`New option "${newValue?.description}" added.`, { variant: 'success' })
      // only close if submission is successful
      props.onClose()
    } else {
      enqueueSnackbar('Failed to add new option. Please try again.', { variant: 'error' })
    }
  }

  return <FormProvider {...form}>
    <Dialog {...props}>
      <DialogTitle>Add New Option</DialogTitle>
      <DialogContent sx={{ px: 3 }}>
        <Alert severity="info">You are adding a new option to the field <b>{parent.label || parent.name}</b>.</Alert>
        <RenderFormSection section={{ headless: true, disableGutters: true, fields }}
          optionsMap={optionsMap}
        />
      </DialogContent>



      <DialogActions>
        <Button onClick={() => props.onClose()}>Cancel</Button>
        <Button onClick={form.handleSubmit(handleSubmit, onError)} variant="contained">Add</Button>
      </DialogActions>
    </Dialog>
  </FormProvider>
}